<script lang="ts">
	import { page } from '$app/stores';
	import Button from '$lib/components/buttons/Button.svelte';
	const message = $page?.error?.message ?? 'Not Found';
	const status = $page?.status ?? '404';
</script>

<div class="error-page page">
	<div class="top">
		<a href="/">
			<img src="/logo.png" alt="Dock411 Logo" class="logo" />
		</a>
	</div>
	<div class="center">
		<figure style="position: relative;">
			<img src="/404-not-found.jpg" alt="Flustered truck driver" />
			<div class="center-text">
				<span>
					<h1>Oops</h1>
					<h2>Something Went Wrong.</h2>
				</span>
				<p>{status} {message}</p>
			</div>
		</figure>
	</div>
	<div class="bottom">
		<Button color="dark" href="/">Go Back Home</Button>
	</div>
</div>
